// Marking of written notes (ÖSD C1 Hören Aufgabe 2, part taskType 'lecture').
//
// The Modellsatz: "Die Notiz muss sinnvoll ergänzt werden und die Lösung inhaltlich
// passend sein. Orthografie- und Grammatikfehler werden nicht bewertet. Auch andere
// Lösungen … werden als richtig gewertet, wenn sie inhaltlich identisch (Synonyme) sind."
// So a note is right when it matches one of the key's alternatives ("a / b", or a
// list) leniently: case, punctuation, umlauts, articles and small typos do not
// count; numbers must match exactly. Synonyms outside the key are not recognised.

export const isNotesPart = (part) => part?.taskType === 'lecture';

const ARTICLES = new Set(['der', 'die', 'das', 'den', 'dem', 'des', 'ein', 'eine', 'einen', 'einem', 'einer', 'eines']);

const fold = (value) => String(value ?? '')
  .toLowerCase()
  .replace(/%/g, ' prozent ')
  .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
  .replace(/[^a-z0-9]+/g, ' ')
  .split(' ')
  .filter((w) => w && !ARTICLES.has(w))
  .join(' ');

const alternativesOf = (key) => (Array.isArray(key) ? key : String(key ?? '').split(/\s+\/\s+/))
  .map(fold)
  .filter(Boolean);

const distance = (a, b) => {
  const row = Array.from({ length: b.length + 1 }, (_, j) => j);
  for (let i = 1; i <= a.length; i += 1) {
    let prev = row[0];
    row[0] = i;
    for (let j = 1; j <= b.length; j += 1) {
      const cur = row[j];
      row[j] = Math.min(row[j] + 1, row[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = cur;
    }
  }
  return row[b.length];
};

const digits = (s) => (s.match(/\d+/g) || []).join(',');

/** Spelling slips allowed for a note of this length (none for short words). */
const allowance = (s) => (s.length >= 12 ? 2 : s.length >= 5 ? 1 : 0);

export function isNoteCorrect(key, answer) {
  const got = fold(answer);
  if (!got) return false;
  return alternativesOf(key).some((want) => {
    if (digits(want) !== digits(got) && digits(want)) return false;
    if (got === want) return true;
    if (distance(got, want) <= allowance(want)) return true;
    // The key inside a slightly longer note ("ca. 9 Stunden täglich").
    const words = got.split(' ');
    return words.length <= want.split(' ').length + 2 && ` ${got} `.includes(` ${want} `);
  });
}
